import { toast } from "react-toastify";
import { useState } from "react";
import { useQuery } from "react-query";
import { useForm } from "react-hook-form";
//primereact
import { Button } from "primereact/button";
import { Fieldset } from "primereact/fieldset";
import { Skeleton } from "primereact/skeleton";
import { BreadCrumb } from "primereact/breadcrumb";
//components
import Panel from "../../../components/panel/panel";
import Switch from "../../../components/input/Switch";
//services
import { getRemittanceReturn } from "../../../services/GlobalRoles/getRemittanceReturn";
import { editRemittanceReturns } from "../../../services/Settings/FinancialRemittanceReturn/editRemittanceReturn";
import { useAppContext } from "../../../context/AppContext";

const FinancialRemittanceReturn = () => {
  const { permissions } = useAppContext();
  const {
    control: controlRemittanceReturn,
    handleSubmit: handleReturn,
    formState: { errors },
  } = useForm();

  const getFormErrorMessage = (name) => {
    return errors[name] ? (
      <small className="p-error">{errors[name].message}</small>
    ) : (
      <small className="p-error">&nbsp;</small>
    );
  };

  const items = [
    {
      label: "Retornos de Remessa",
      url: "/",
    },
  ];
  const home = {
    icon: "fa fa-home",
  };

  const [loading, setLoading] = useState(true);
  const [financialReturnData, setFinancialReturnData] = useState({});

  const initializeFinancialReturnData = (data) => {
    const initialData = {
      banco_brasil: 0,
      bradesco: 0,
      caixa: 0,
      itau: 0,
      sicoob: 0,
      safra: 0,
      barinsul: 0,
      santander: 0,
      // Adicione outras propriedades conforme necessário
    };

    for (const key in data) {
      if (Object.prototype.hasOwnProperty.call(data, key)) {
        if (data[key] !== undefined) {
          initialData[key] = data[key] ? 1 : 0;
        }
      }
    }

    return initialData;
  };

  const isChecked = (value) => {
    return value === 1;
  };
  const transformObjectValues = (financialReturnData, data) => {
    const transformedData = { ...financialReturnData };

    for (const key in data) {
      if (Object.prototype.hasOwnProperty.call(data, key)) {
        if (data[key] !== undefined) {
          transformedData[key] = data[key] ? 1 : 0;
        }
      }
    }

    return transformedData;
  };

  const sendSubmitReturns = async (data) => {
    try {
      const updatedFinancialReturnData = transformObjectValues(
        financialReturnData,
        data
      );
      setLoading(true);
      toast.warning("Aguarde, Alterando Permissões...");
//      console.log(data);
//      console.log(financialReturnData);
//      console.log(updatedFinancialReturnData);
      await editRemittanceReturns(updatedFinancialReturnData);
      toast.success("Permissões Alteradas com Sucesso!");

      refetch();
    } catch (error) {
      toast.error("Não foi Possível Alterar as Permissões!");
    }
  };

  const legendTemplate = (
    <div className="text-start d-flex justify-content-start text-success">
      <span className="pi pi-bitcoin mx-2"></span>
      <h4>Bancos</h4>
    </div>
  );

  const {
    data: financialReturn,
    isLoading: isLoadingIndex,
    refetch,
  } = useQuery(
    "financialReturn", 
    () => getRemittanceReturn(), {
    onSuccess: (data) => {
      setFinancialReturnData(initializeFinancialReturnData(data));
      setLoading(false);
    },
    enabled: false //essa tela nao existe mais
  });

  return (
    <>
      <div className="col-md-4">
        <BreadCrumb
          model={items}
          home={home}
          style={{
            background: "transparent",
            border: "none",
            fontSize: "16px",
          }}
        />
      </div>
      <form onSubmit={handleReturn(sendSubmitReturns)}>
        {loading && (
          <div className="col-md-12">
            <div className="card flex rounded-4 px-4">
              <div className="flex mb-5">
                <div className="py-3">
                  <Skeleton width="75%" height="2rem"></Skeleton>
                </div>
              </div>
              <div className="pb-2">
                <Skeleton width="100%" height="50px"></Skeleton>
              </div>
            </div>
          </div>
        )}
        {!loading && (
          <Panel mainCss="mb-4" title="Retornos de Remessa Financeiro">
            <Fieldset legend={legendTemplate}>
              <div className="d-flex row">
                <div className="col-md-2">
                  <p className="m-auto pb-2">Retorno BB</p>
                  <Switch
                    name="banco_brasil"
                    defaultValue={0}
                    checked={isChecked(financialReturn?.banco_brasil || 0)}
                    control={controlRemittanceReturn}
                    getFormErrorMessage={getFormErrorMessage}
                    onChange={(e) =>
                      setFinancialReturnData({
                        ...financialReturnData,
                        banco_brasil: e.value ? 1 : 0,
                      })
                    }
                  />
                </div>
                <div className="col-md-2 py-2">
                  <p className="m-auto pb-2">Retorno Bradesco</p>
                  <Switch
                    name="bradesco"
                    checked={isChecked(financialReturn?.bradesco || 0)}
                    control={controlRemittanceReturn}
                    getFormErrorMessage={getFormErrorMessage}
                    onChange={(e) =>
                      setFinancialReturnData((prevData) => ({
                        ...prevData,
                        bradesco: e.value ? 1 : 0,
                      }))
                    }
                  />
                </div>
                <div className="col-md-2 py-2">
                  <p className="m-auto pb-2">Retorno Caixa</p>
                  <Switch
                    name="caixa"
                    checked={isChecked(financialReturn?.caixa || 0)}
                    control={controlRemittanceReturn}
                    getFormErrorMessage={getFormErrorMessage}
                    onChange={(e) =>
                      setFinancialReturnData((prevData) => ({
                        ...prevData,
                        caixa: e.value ? 1 : 0,
                      }))
                    }
                  />
                </div>
                <div className="col-md-2 py-2">
                  <p className="m-auto pb-2">Retorno Itau</p>
                  <Switch
                    name="itau"
                    checked={isChecked(financialReturn?.itau || 0)}
                    control={controlRemittanceReturn}
                    getFormErrorMessage={getFormErrorMessage}
                    onChange={(e) =>
                      setFinancialReturnData((prevData) => ({
                        ...prevData,
                        itau: e.value ? 1 : 0,
                      }))
                    }
                  />
                </div>
                <div className="col-md-2 py-2">
                  <p className="m-auto pb-2">Retorno Sicoob</p>
                  <Switch
                    name="sicoob"
                    checked={isChecked(financialReturn?.sicoob || 0)}
                    control={controlRemittanceReturn}
                    getFormErrorMessage={getFormErrorMessage}
                    onChange={(e) =>
                      setFinancialReturnData((prevData) => ({
                        ...prevData,
                        sicoob: e.value ? 1 : 0,
                      }))
                    }
                  />
                </div>
                <div className="col-md-2 py-2">
                  <p className="m-auto pb-2">Retorno Safra</p>
                  <Switch
                    name="safra"
                    checked={isChecked(financialReturn?.safra || 0)}
                    control={controlRemittanceReturn}
                    getFormErrorMessage={getFormErrorMessage}
                    onChange={(e) =>
                      setFinancialReturnData((prevData) => ({
                        ...prevData,
                        safra: e.value ? 1 : 0,
                      }))
                    }
                  />
                </div>
                <div className="col-md-2 py-2">
                  <p className="m-auto pb-2">Retorno Barinsul</p>
                  <Switch
                    name="barinsul"
                    checked={isChecked(financialReturn?.barinsul || 0)}
                    control={controlRemittanceReturn}
                    getFormErrorMessage={getFormErrorMessage}
                    onChange={(e) =>
                      setFinancialReturnData((prevData) => ({
                        ...prevData,
                        banrisul: e.value ? 1 : 0,
                      }))
                    }
                  />
                </div>
                <div className="col-md-2 py-2">
                  <p className="m-auto pb-2">Retorno Santander</p>
                  <Switch
                    name="santander"
                    checked={isChecked(financialReturn?.santander || 0)}
                    control={controlRemittanceReturn}
                    getFormErrorMessage={getFormErrorMessage}
                    onChange={(e) =>
                      setFinancialReturnData((prevData) => ({
                        ...prevData,
                        santander: e.value ? 1 : 0,
                      }))
                    }
                  />
                </div>
              </div>
              <div className="row justify-content-center">
                <div className="col-md-2 form-group">
                  <Button
                    type="submit"
                    icon="fa fa-repeat"
                    label="Atualizar"
                    aria-label="Search"
                    className={`rounded-3 w-100`}
                  />
                </div>
              </div>
            </Fieldset>
          </Panel>
        )}
      </form>
    </>
  );
};

export default FinancialRemittanceReturn;
